<template>
  <div style="height: calc(100vh - 196px);margin-top:25px;">
    <vxe-table
      ref="xTable"
      export-config
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="branchArr"
      sort-config.remote
      align="center"
      @sort-change="sortList"
    >
      <!-- <vxe-table-column>

      </vxe-table-column> -->
      <vxe-table-column
        field="groupName"
        title="承运主体"
        min-width="80"
        sortable
      />
      <vxe-table-column
        field="taxPoint"
        title="服务费率(%)"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="name"
        title="平台服务经理"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="salesmanPhone"
        title="平台服务经理手机号"
        min-width="100"
        sortable
      />
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/roleAdd";
import compPermission from "./components/rolePermission";
import compNotice from "./components/roleNotice";
import appNotice from "./components/appNotice";
import request from "@/utils/request";
import { getPartyInfo } from "@/api/shipment";
export default {
  name: "JurisdictManage",
  components: {
    compAdd,
    compPermission,
    compNotice,
    appNotice
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          partyCode: "",
          branchCode: ""
        };
      }
    }
  },
  data() {
    return {
      listQuery: {
        groupName: "",
        taxPoint: "",
        name: "",
        salesmanPhone: ""
      },
      branchArr: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/role/exportRole", //导出接口
        name: "权限管理"
      },
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modeladdTitle: "新增",
      modelNoticeFlag: false,
      modelPermissionFlag: false,
      modelappNoticeFlag: false,
      isCompanyShipmentOrAdmin: false,
      copy: false,
      listQuery: {
        shipmentCode: "",
        branchCode: "",
        role: "",
        roleName: "",
        type: "",
        description: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 类型
      typeList: [
        { label: "托运人添加", value: 0 },
        { label: "内置角色", value: 1 },
        { label: "内置托运人员工角色", value: 2 }
      ]
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isCompanyShipmentOrAdmin = partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.listQuery.shipmentCode = this.parentData.partyCode;
    this.listQuery.branchCode = this.parentData.branchCode;
    this.getPartyInfo();
  },
  methods: {
    getPartyInfo() {
      console.log("getPartyInfo========", this.parentData);
      getPartyInfo({
        partyCode: this.$store.state.user.code
      })
        .then(response => {
          console.log("=========", response);
          this.branchArr = response.data;
        })
        .catch(call => {
          this.$message({ message: call.msg, type: "error" });
        });
    },
    findList() {
      return new Promise(resolve => {
        this.loading = true;
        request({
          url: "/ntocc-basic-api/role",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 添加方法
    funcAdd(type, code) {
      this.modelAddFlag = true;
      this.modeladdTitle =
        type == "add" ? "新增" : type == "edit" ? "编辑" : "详情";
      this.$refs.addRef.getInfo(type, code);
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/role`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "permission":
          this.modelPermissionFlag = false;
          break;
        case "notice":
          this.modelNoticeFlag = false;
          break;
        case "appNotice":
          this.modelappNoticeFlag = false;
          break;
        default:
      }
    },
    // 翻译类型
    formatterType({ cellValue }) {
      const item = this.typeList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 授权
    funcPermission(code) {
      this.$refs.permissionRef.getInfo(code);
      this.modelPermissionFlag = true;
    },
    // 授权通知
    funcAuthorizeNotice(code) {
      this.$refs.noticeRef.getInfo(code);
      this.modelNoticeFlag = true;
    },
    // 授权通知
    funcAppNotice(code) {
      this.$refs.appnoticeRef.getInfo(code);
      this.modelappNoticeFlag = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
